import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
  CanActivateChild
} from "@angular/router";
import { Observable } from "rxjs";
import { JwtService } from "../services/jwt.service";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private jwt: JwtService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    router: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Promise<boolean | UrlTree>
    | Observable<boolean | UrlTree> {
    if (this.jwt.isTokenActive()) {
      return true;
    }
    return this.router.createUrlTree(["/"]);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    router: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Promise<boolean | UrlTree>
    | Observable<boolean | UrlTree> {
    if (router.url === "/dashboard/401" || router.url === "/dashboard/logout")
      return true;
    if (this.jwt.isTokenActive()) {
      if (!this.jwt.isExpired()) {
        return true;
      }
    }
    return this.router.createUrlTree(["/dashboard/401"]);
  }
}
